import { Injectable, Optional, Inject, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { News, PageData } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  #http = inject(HttpClient);
  #BASE_URL = inject(BASE_URL, { optional: true });

  getNews(profileId: number, skip: number = 0, take: number = 0) {
    return this.#http.get<{ items: News[]; page: PageData }>(
      `${this.#BASE_URL}api/disease-profiles/${profileId}/news?take=${take}&skip=${skip}`
    );
  }

  getNewsDetail(id: number) {
    return this.#http.get<News>(`${this.#BASE_URL}api/news/${id}`);
  }
}
